import { render } from "./HDGatepassPrint.vue?vue&type=template&id=673ef64c&scoped=true"
import script from "./HDGatepassPrint.vue?vue&type=script&lang=js"
export * from "./HDGatepassPrint.vue?vue&type=script&lang=js"

import "./HDGatepassPrint.vue?vue&type=style&index=0&id=673ef64c&scoped=true&lang=css"
import "./HDGatepassPrint.vue?vue&type=style&index=1&id=673ef64c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-673ef64c"]])

export default __exports__